import { put , call, takeEvery} from 'redux-saga/effects';
import {setApiStatus, getApprovalList, setSideNavs, setSelectedTab} from '../actions/ApprovalListActions';
import ApprovalService from "../services/ApprovalService";
import LoggerService from "../services/LoggerService";
import store from "../stores/store";
import _ from 'lodash';
import { ACTIVITY, ACTIVITY_CATEGORY } from '../constants/LogConstants';
import { getApprovalListDataModel } from '../models/ApprovalListDto';


export function* approvalFlowSaga(){

    yield takeEvery('GET_APPROVAL_FLOW', function* (action){
        const { customerGuid } = action;
        yield call(approvalFlowActionSaga,customerGuid);
    })  
}

export function* approvalFlowActionSaga(customerGuid){
    const userInfo = _.get(store.getState(), "AuthReducer.userInfo", {});
    try{
        const response = yield call(ApprovalService.getApprovalFlows,customerGuid);
        yield put(setApiStatus(true));
        if (response) {
            let sidePanelData = getApprovalListDataModel(response.data);
            // set side nav panels
            yield put(setSideNavs(sidePanelData));
            //set first one as selected tab ID, workflowID
            let flowInfoId = sidePanelData[0].id;
            yield put(setSelectedTab(flowInfoId));
            // get approvalList
            yield put(getApprovalList(flowInfoId));
            const messageObject = {};
            messageObject.Message = "Fetched approval flows successfully";
            messageObject.Functionality = ACTIVITY.FETCH_APPROVAL_FLOWS;
            messageObject.ActivityCategory = ACTIVITY_CATEGORY.FETCH;
            messageObject.Source_System = "Commerce";
            messageObject.Flow = "Get Approval Flows";
            messageObject.Screen = "CustomerApprovalPortal";
            messageObject.AgentId = "";
            messageObject.CustomerGuid = customerGuid || (_.has(userInfo, "userId") ? userInfo.userId : "");
            messageObject.countryCode = _.has(userInfo, "countryCode") ? userInfo.countryCode : "";
            messageObject.Result = 'Success';
            LoggerService.saveSplunkLog(messageObject, 'info');
        }

    }catch(error){
        yield put(setApiStatus(false));
        const messageObject = {};
        messageObject.Message = "Failed to fetch approval flows";
        messageObject.Functionality = ACTIVITY.FETCH_APPROVAL_FLOWS;
        messageObject.ActivityCategory = ACTIVITY_CATEGORY.FETCH;
        messageObject.Source_System = "Commerce";
        messageObject.Flow = "Get Approval Flows";
        messageObject.Screen = "CustomerApprovalPortal";
        messageObject.AgentId = "";
        messageObject.CustomerGuid = customerGuid || (_.has(userInfo, "userId") ? userInfo.userId : "");
        messageObject.countryCode = _.has(userInfo, "countryCode") ? userInfo.countryCode : "";
        messageObject.errorMessage = error && error.message ? error.message : '';
        messageObject.Result = 'Failure';
        LoggerService.saveSplunkLog(messageObject, 'error');
    }

}

